// @flow

export const range = (from: number, to: number): number[] => {
  const length = to - from;
  return Array.from({ length }, (_, i) => i + from);
};
